<template>
    <div data-module="announcement">
        <p>Particle acquired by Wind River</p>
    </div>
</template>

<script>
// Components
// import MouseEventContainer from '@/components/MouseEventContainer';

export default {

  name: 'announcement',

  // components: { MouseEventContainer },

  props: ['data'],

 /* computed: {

    heading() {
      const heading = this.data.heading;
      if (this.haveJobs) {
        return heading.jobs;
      }
      return heading.noJobs;
    },

    teaser() {
      const teaser = this.data.teaser;
      if (this.haveJobs) {
        return teaser.jobs;
      }
      return teaser.noJobs;
    },

    noJobsContent() {
      return this.data.noJobsContent;
    },

    haveJobs() {
      return (this.data.listings.length > 0);
    },

  }, */

};
</script>


<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="announcement"] {
  @include grid($subgrid: true, $rows: 2);
  @include spacer();


    display: block;
    background-color: chartreuse;
    width: 100%;
    height: 111px;
    z-index: 1;

    position: absolute;
    top: rem(94px);



 /* h1 {
    @include type('h1-default');
  }

  [data-ornament] {
    display: block;
    margin-bottom: rem(30px);
    width: rem(80px);
  } */

  @include mq($bp--tablet, down) {
    grid-template-rows: repeat(3, auto);

  /*  .headline {
      grid-row: 1;
      grid-column: 1 / 7;
    } */
  }

  @include mq($bp--mobile, down) {
    grid-template-rows: repeat(3, auto);



  }
}

</style>



// WEBPACK FOOTER //
// src/modules/announcement.vue